import { Content } from 'antd/es/layout/layout';
import AllDashbord from '../components/Dashbord/AllDashbord';

function DashboardPage() {

  return (
     <Content style={{ overflow: 'initial' }}>
      <AllDashbord />
    </Content>
  );
}

export default DashboardPage;
